import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Alert: ComponentStyleConfig = {
  parts: [
    'ChakraAlert',
    'AlertContainer',
    'AlertTitle',
    'AlertDescription',
    'AlertIcon',
    'CloseButton',
  ],
  baseStyle: () => {
    return {
      ChakraAlert: {},
      AlertContainer: {
        mr: 4,
      },
      AlertTitle: {},
      AlertDescription: {},
      AlertIcon: {
        mb: 'auto',
      },
      CloseButton: {
        alignSelf: 'flex-start',
        position: 'absolute',
        right: 1,
        top: 1,
      },
    };
  },
};

export default Alert;
